import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const SlideSearchShareIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-slide-search-share-icon ${className}`, height: '23', viewBox: '0 0 23 23', width: '23', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M22.7,2H4.3A2.3,2.3,0,0,0,2.011,4.3L2,25l4.6-4.6H22.7A2.307,2.307,0,0,0,25,18.1V4.3A2.307,2.307,0,0,0,22.7,2ZM5.45,15.8l4.025-5.175,2.875,3.462L16.375,8.9l5.175,6.9Z', fill: '#a1a7b2', transform: 'translate(-2 -2)' }) })));
SlideSearchShareIcon.propTypes = {
    className: propStr(),
};
SlideSearchShareIcon.defaultProps = {
    className: '',
};
export default SlideSearchShareIcon;
